<template>
  <div>
    <div :class="chartClass" v-show="mainChartVisible">
      <div :class="(subChartData.length > 0) ? 't-chart c-pointer' : 't-chart'">
        <div :class="(subChartData.length > 0) ? 'title corner' : 'title'" @click="onClickAddButton">
            구간별 응답시간
            <div :class="addButtonIconName" v-show="subChartData.length > 0"></div>
        </div>
        <w-plot-area-chart ref="e2eMainResponseChart" :active="active" :visible="mainChartVisible" :rscInfoList="mainRscInfoList" :objInfo="mainChartData" :showObjName="true" @clickChart="onClickChart"/>
      </div>
    </div>
    <div v-show="subChartVisible" class="sub-chart-wrapper">
      <div class="list-analytics analysis-chart" v-for="(chartData, idx) in subChartData" :key="chartData.objId">
        <div class="t-chart">
          <div class="title">구간별 응답시간</div>
          <w-plot-area-chart :ref= "`e2eSubResponse${idx}Chart`" :active="active" :visible="subChartVisible" :rscInfoList="mainRscInfoList" :objInfo="chartData" :showObjName="true" @clickChart="onClickChart"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import pullAt from 'lodash/pullAt';
import clone from 'lodash/clone';

import { performanceChart } from '@/mixins/performance/charts';
import WPlotAreaChart from '@/views/performance/node/analysis/components/PlotAreaChart';

export default {
  name: 'WServiceResponsetimeAnalysisChart',
  components: { WPlotAreaChart },
  mixins: [performanceChart],
  props: {
    chartVisible: Boolean,
    agentData: Array,
  },
  data() {
    return {
      subChartVisible: false,
      addButtonVisible: false,
      mainChartData: {},
      subChartData: [],
    };
  },
  computed: {
    chartClass() {
      const chartClass = 'list-analytics analysis-chart';
      /* if (this.addButtonVisible) {
        chartClass += ' expandable';
      } */
      return chartClass;
    },
    ...mapGetters(['selectedNode']),
  },
  watch: {
    selectedNode: {
      immediate: true,
      /**
       * E2E 관리대상을 선택할 때마다 rscInfoList를 만든다.
       * @return {[type]} [description]
       * @author jda
       */
      handler(node) {
        if (!this.active) {
          return;
        }
        if (this.chartVisible) {
          const rscKey = node.rscKey;
          this.mainRscInfoList = [
            { rsctypeId: 'SERVICESTATUS', rscId: 'RESPONSETIME_NAMELOOKUP', rscKey },
            { rsctypeId: 'SERVICESTATUS', rscId: 'RESPONSETIME_HOST_SERVER_CONNECT', rscKey },
            { rsctypeId: 'SERVICESTATUS', rscId: 'RESPONSETIME_SERVICE_WAIT', rscKey },
            { rsctypeId: 'SERVICESTATUS', rscId: 'RESPONSETIME_FILE_TRANSFER', rscKey },
            { rsctypeId: 'SERVICESTATUS', rscId: 'RESPONSETIME_DB_SERVICE', rscKey },
          ];
        }
      },
    },
    /**
     * 대표 에이전트를 메인 차트로, 나머지 에이전트는 서브 차트로 표현한다.
     * @param  {[type]} result [description]
     * @return {[type]}        [description]
     * @author jda
     */
    agentData(agentDataList) {
      const result = clone(agentDataList);
      this.addButtonVisible = result.length > 1;
      this.mainChartData = result[0];

      pullAt(result, 0);
      this.subChartData = result;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/e2e/components/chart/ServiceResponsetimeAnalysisChart.vue